module.exports = __webpack_public_path__ + "img/pyro-poster.1f9f6bd5.jpg";